import { Controller } from 'stimulus'
import SimpleParallax from "simple-parallax-js/vanilla"

export default class ParallaximageController extends Controller {
  connect() {
    // HACK: remove data-controller attribute to prevent re-initialization
    this.element.removeAttribute("data-controller")

    this.parallax = new SimpleParallax(this.element, {
      scale: 1.25,
      orientation: "down",
      maxTransition: 70,
    })
  }

  disconnect() {
    // this.parallax.destroy()
  }
}